import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/storage';

import { config } from '../config';

firebase.initializeApp(config);

export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();

if (config.env === 'local') {
    db.settings({
        host: config.firestoreHost,
        ssl: false,
    });
    storage.useEmulator('localhost', 9199);
}
